'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils = require("./");

exports.fromETHBlockNumber = function (blockNumber) {
  if (typeof blockNumber === 'number') {
    return blockNumber;
  } else if (typeof blockNumber === 'string') {
    if (blockNumber === 'earliest') {
      return 0;
    } else if (blockNumber === 'latest' || blockNumber === 'pending') {
      return 'best';
    } else {
      var num = utils.toInteger(blockNumber);
      return num || num === 0 ? num : 'best';
    }
  } else {
    return 'best';
  }
};

exports.fromETHBlockNumberOrHash = function (blockRevision) {
  if (/^(-0x|0x)?[0-9a-fA-F]{64}$/i.test(blockRevision)) {
    return blockRevision;
  } else {
    return exports.fromETHBlockNumber(blockRevision);
  }
};

exports.formatRange = function (range) {
  var ret = {};

  if (range.unit !== 'block' && range.unit !== 'time') {
    return null;
  } else {
    ret.unit = range.unit;
  }

  if (range.hasOwnProperty('from')) {
    var temp = exports.fromETHBlockNumber(range.from);

    if (temp !== 'best') {
      ret.from = temp;
    } else {
      ret.from = 0;
    }
  } else {
    ret.from = 0;
  }

  if (range.hasOwnProperty('to')) {
    var _temp = utils.fromETHBlockNumber(range.to);

    if (_temp !== 'best') {
      ret.to = _temp;
    } else {
      ret.to = Number.MAX_SAFE_INTEGER;
    }
  } else {
    ret.to = Number.MAX_SAFE_INTEGER;
  }

  return ret;
};

exports.formatOptions = function (options) {
  var ret = {};

  if (options.hasOwnProperty('limit')) {
    var temp = utils.toInteger(options.limit);

    if (temp) {
      ret.limit = temp;
    }
  }

  if (options.hasOwnProperty('offset')) {
    var _temp2 = utils.toInteger(options.offset);

    if (_temp2) {
      ret.offset = _temp2;
    }
  }

  if (ret.hasOwnProperty('limit') || ret.hasOwnProperty('offset')) {
    return ret;
  } else {
    return null;
  }
};

exports.formatLogQuery = function (params) {
  var body = {
    topicSets: []
  };

  if (params.range) {
    var ret = exports.formatRange(params.range);

    if (ret) {
      body.range = ret;
    }
  }

  if (params.options) {
    var _ret = exports.formatOptions(params.options);

    if (_ret) {
      body.options = _ret;
    }
  }

  if (!body.range && (params.hasOwnProperty('fromBlock') || params.hasOwnProperty('toBlock'))) {
    body.range = {
      unit: 'block'
    };

    if (params.hasOwnProperty('fromBlock')) {
      body.range.from = params.fromBlock;
    }

    if (params.hasOwnProperty('toBlock')) {
      body.range.to = params.toBlock;
    }

    body.range = exports.formatRange(body.range);
  }

  body.topicSets = [];
  var topics = [];

  if (params.topics && params.topics.length) {
    for (var i = 0; i < params.topics.length; i++) {
      if (typeof params.topics[i] === 'string') {
        topics.push({
          name: 'topic' + i,
          array: [params.topics[i]]
        });
      } else if (utils.isArray(params.topics[i]) && params.topics[i].length) {
        topics.push({
          name: 'topic' + i,
          array: params.topics[i]
        });
      }
    }
  }

  var outputTopic = function outputTopic(inputTopics, index, receiver, current) {
    if (index === inputTopics.length) {
      var o = {};
      Object.assign(o, current);
      receiver.push(o);
      return;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = inputTopics[index].array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;
        current[inputTopics[index].name] = item;
        outputTopic(inputTopics, index + 1, receiver, current);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  if (topics.length) {
    outputTopic(topics, 0, body.topicSets, {});
  }

  return body;
};